<div class="dialog">
  <div class="dialog-header">
    <span class="dialog-title">{{ isEdit ? 'Edit view' : 'Add view' }}</span>
    <button type="button" class="close-btn" [disabled]="isLoading" (click)="close()" aria-label="Close">×</button>
  </div>

  <form [formGroup]="form" class="dialog-form">
    <div class="field-row">
      <div class="field"><span class="field-label">View name</span><input class="text-box-active" formControlName="viewName" /></div>
      <div class="field"><span class="field-label">Label</span><input class="text-box-active" formControlName="viewLabel" /></div>
    </div>
    <div class="field-row">
      <div class="field">
        <span class="field-label">Type</span>
        <mat-form-field class="ac-select-field" appearance="outline" subscriptSizing="dynamic">
          <mat-select panelClass="ac-select-panel" [disableOptionCentering]="true" formControlName="viewType">
            <mat-option value="C">Category</mat-option>
            <mat-option value="T">Leaf (screen)</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="field">
        <span class="field-label">Parent view</span>
        <mat-form-field class="ac-select-field" appearance="outline" subscriptSizing="dynamic">
          <mat-select panelClass="ac-select-panel" [disableOptionCentering]="true" formControlName="parentViewId">
            <mat-option [value]="null">None (top level)</mat-option>
            @for(p of parents; track p.viewId){ <mat-option [value]="p.viewId">{{ p.viewLabel }}</mat-option> }
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <div class="field-row">
      <div class="field"><span class="field-label">Level</span><input type="number" class="text-box-active" formControlName="level" /></div>
      <div class="field"><span class="field-label">Display order</span><input type="number" class="text-box-active" formControlName="displayOrder" /></div>
    </div>
    <div class="field-row">
      <div class="field">
        <span class="field-label">Applicable for</span>
        <mat-form-field class="ac-select-field" appearance="outline" subscriptSizing="dynamic">
          <mat-select panelClass="ac-select-panel" [disableOptionCentering]="true" formControlName="applicableFor">
            <mat-option value="CENTRAL">Central</mat-option>
            <mat-option value="ESTABLISHMENT">Establishment</mat-option>
            <mat-option value="BOTH">Both</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="field">
        <span class="field-label">Status</span>
        <mat-form-field class="ac-select-field" appearance="outline" subscriptSizing="dynamic">
          <mat-select panelClass="ac-select-panel" [disableOptionCentering]="true" formControlName="status">
            <mat-option [value]="1">Active</mat-option>
            <mat-option [value]="0">Inactive</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <div class="field-row">
      <div class="field"><span class="field-label">Web route</span><input class="text-box-active" formControlName="webRoute" /></div>
      <div class="field"><span class="field-label">App route</span><input class="text-box-active" formControlName="appRoute" /></div>
    </div>
    <div class="field-row">
      <div class="field"><span class="field-label">Icon</span><input class="text-box-active" formControlName="icon" /></div>
      <div class="field"><span class="field-label">Icon (active)</span><input class="text-box-active" formControlName="iconActive" /></div>
    </div>
    <div class="field-row">
      <div class="field"><span class="field-label">App icon</span><input class="text-box-active" formControlName="appIcon" /></div>
      <div class="field"><span class="field-label">View mode</span><input class="text-box-active" formControlName="viewMode" /></div>
    </div>
  </form>

  <div class="dialog-actions">
    <button type="button" class="ac-secondary-btn" (click)="close()">Close</button>
    <button type="button" class="ac-primary-btn" (click)="submit()">{{ isEdit ? 'Save' : 'Add' }}</button>
  </div>
</div>

<app-loader [isLoading]="isLoading"></app-loader>
